import React from 'react';
import { Avatar } from 'antd';
import { AccountInfoType } from 'works/legacy/lib/auth';
import { UserAvatar, Icon } from '@common/components';

type Props = {
  account: AccountInfoType;
  size: number;
  style?: { [key: string]: unknown };
};

export function AccountAvatar({ account, size, style }: Props) {
  if (account.logo) {
    return (
      <Avatar
        size={size}
        style={{ backgroundColor: account.color, ...style }}
        src={account.logo}
      />
    );
  }

  if (account.entityType === 'Organization') {
    return (
      <Avatar
        size={size}
        style={{ backgroundColor: account.color, ...style }}
        icon={<Icon icon="hospital" kind="solid" size="md" />}
      />
    );
  }

  return (
    <UserAvatar
      size={size}
      style={style}
      backgroundColor={account.color}
      textAsInitials={account.entityName}
    />
  );
}
